import { render, staticRenderFns } from "./PrivateChatRepresentative.vue?vue&type=template&id=040bf630&scoped=true"
import script from "./PrivateChatRepresentative.vue?vue&type=script&lang=js"
export * from "./PrivateChatRepresentative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040bf630",
  null
  
)

export default component.exports